export default "__VITE_ASSET__ae1928d7__"